export default "__VITE_ASSET__BdVbWFhs__"